import { render, staticRenderFns } from "./tab-content-item.vue?vue&type=template&id=7481a6a8"
import script from "./tab-content-item.vue?vue&type=script&lang=js"
export * from "./tab-content-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports